import { fetchResource } from '@/services/fetchService'

class OrgService {
  constructor() {
    this.type = ''
  }

  fetchOrgs = async () => {
    const orgs = await fetchResource('orgs')
    return orgs
  }

  fetchOrgPersons = async ({ orgKey, portalKey }) => {
    const people = fetchResource(`org/${orgKey}/portal/${portalKey}`)
    return people
  }

  fetchOrg = async (orgKey) => {
    const org = await fetchResource(`org/${orgKey}`)
    return org
  }
}

export default OrgService
export const orgService = new OrgService()
